import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    Output,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

import { TabNode } from '../insight/experimental.tabset';

@Component({
    selector: '[cmpsInsightExplorerTabRename]',
    template: ` <div
        role="form"
        [formGroup]="form"
    >
        <input
            type="text"
            class="form-control mb-3"
            formControlName="value"
            (keyup.enter)="onRenameClick()"
        />
        <div class="text-nowrap">
            <button
                class="btn btn-primary"
                (click)="onCancelClick()"
            >
                Cancel
            </button>
            <button
                class="btn btn-primary active"
                (click)="onRenameClick()"
            >
                Rename
            </button>
        </div>
    </div>`,
    host: {
        class: 'cmps-cdk-border-width-1p cmps-cdk-border-solid cmps-cdk-border-color-grey-300',
    },
})
export class TabRenameInsightExplorerComponent implements OnDestroy {
    form: FormGroup;
    private _id: string;

    // eslint-disable-next-line accessor-pairs
    @Input()
    set tab(value: TabNode) {
        this._id = value.def.id;
        this.form.patchValue(
            { value: value.def.ctx.label },
            { emitEvent: false },
        );
    }

    @Output()
    renameCancel: EventEmitter<void>;

    @Output()
    renameValue: EventEmitter<{ id: string; label: string }>;

    constructor(private readonly _formBuilder: FormBuilder) {
        this.form = this._formBuilder.group({
            value: [null],
        });
        this.renameCancel = new EventEmitter();
        this.renameValue = new EventEmitter();
    }

    ngOnDestroy(): void {
        this.renameCancel.complete();
        this.renameValue.complete();
    }

    onCancelClick(): void {
        this.renameCancel.emit();
    }

    onRenameClick(): void {
        this.renameValue.emit({
            id: this._id,
            label: this.form.value.value,
        });
    }
}
